declare const entityIdBrand: unique symbol;
export type EntityId = number & { readonly [entityIdBrand]: true };

let nextEntityId = 1;
export function createEntityId(): EntityId {
  return nextEntityId++ as EntityId;
}
